export default function CheckMarkIcon() {
  return (
    <svg
      width="16px"
      height="12px"
      viewBox="0 0 16 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Fill</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Icon/Checkmark"
          transform="translate(-4.000000, -6.000000)"
          fill="#0177BD"
        >
          <path
            d="M9.86,18 L9.86000001,18 C9.58283501,17.9991084 9.31847201,17.883223 9.13000001,17.68 L4.27000001,12.51 L4.26999997,12.51 C3.89168497,12.106832 3.91183197,11.47332 4.31500007,11.095 C4.71816807,10.716685 5.35168007,10.736832 5.73000007,11.1400001 C5.73000007,11.1400001 5.73000008,11.1400001 5.73000008,11.1400001 L9.85000008,15.5300001 L18.2600001,6.33000007 L18.26,6.33000019 C18.60581,5.89938019 19.235231,5.83062719 19.66585,6.17643719 C20.09647,6.52224719 20.165223,7.15166819 19.819413,7.58228719 C19.7946959,7.61306619 19.768178,7.64235469 19.7399984,7.66999879 L10.5999984,17.6699988 L10.5999984,17.6699987 C10.4132844,17.8769217 10.1486864,17.9965337 9.86999844,18 L9.86,18 Z" //NOSONAR
            id="Fill"
          ></path>
        </g>
      </g>
    </svg>
  );
}
